export default __webpack_public_path__ + "static/media/material.8d89d3cc.png";